import { renderNavigation } from '@vend/html-navigation'
import angular from 'angular'

import { EVENTS } from '../../constants'
import { $timeout, $transitions } from '../../ng-compat/imports'
import { openRegisterActionsPopover } from '../../state/slices/uiStateSlice'
import { openSaleModal } from '../../components/sale/useSaleModals'

angular
  .module('webregister.directives')
  .directive(
    'wrHtmlNavigation',
    function (
      vdPopover,
      saleSyncManager,
      userManager,
      userSwitchingService,
      trainingModeManager,
      registerManager,
      webRegisterStatusManager,
      $ngRedux
    ) {
      return {
        restrict: 'E',
        link(scope, $element) {
          const toggleTutorialMode = () =>
            (trainingModeManager.tourEnabled = !trainingModeManager.tourEnabled)

          const showRegisterActions = () => {
            $ngRedux.dispatch(openRegisterActionsPopover())
          }

          const triggerAction = () => {
            if (
              saleSyncManager.saleSyncRetryInProgress ||
              !webRegisterStatusManager.isOnline()
            ) {
              return
            }

            if (saleSyncManager.erroredSalesCount) {
              openSaleModal({ type: 'ErroredSales' })
            } else {
              showRegisterActions()
            }
          }

          const render = () => {
            const { name: registerName } =
              registerManager.getActiveRegister() || {}
            const { name: outletName } = registerManager.getActiveOutlet() || {}

            renderNavigation(
              {
                initIntercom: false, // @TODO: Set to true once `vdTracking` is removed (since that currently initializes Intercom)
                offline: !webRegisterStatusManager.isOnline(),
                training: trainingModeManager.trainingModeEnabled,
                tutorial: trainingModeManager.tourEnabled,
                toggleTutorialMode,
                onRegisterInfoClick: () => {
                  triggerAction()
                },
                switchUser: () => {
                  $timeout(
                    userSwitchingService.selectUser.bind(userSwitchingService)
                  )
                },
                signoutUser: () => {
                  userManager.logout()
                },
                register: {
                  registerName,
                  outletName,
                  errorCount: saleSyncManager.erroredSalesCount,
                },
                currentURL: window.location.pathname,
                isError: Boolean(saleSyncManager.erroredSalesCount),
              },
              {
                user: userManager.getLoggedInUser(),
              }
            )
          }

          $timeout(render)

          $transitions.onSuccess({}, render)
          $transitions.onStart({}, transition => {
            window.dispatchEvent(
              new CustomEvent('angular-navigation-start', {
                detail: {
                  from: transition.from().url,
                  to: transition.to().url,
                },
              })
            )
          })

          trainingModeManager.on('tourEnabledChange', render)
          trainingModeManager.on('trainingModeEnabledChange', render)
          registerManager.on('activeRegisterChange', render)
          registerManager.on('activeOutletChange', render)
          userManager.on('loggedInUserChange', render)
          webRegisterStatusManager.on(EVENTS.statusChange, render)
        },
      }
    }
  )
